import { render, staticRenderFns } from "./chartFailure.vue?vue&type=template&id=a36d0076"
import script from "./chartFailure.vue?vue&type=script&lang=js"
export * from "./chartFailure.vue?vue&type=script&lang=js"
import style0 from "./chartFailure.vue?vue&type=style&index=0&id=a36d0076&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports